import { createReducer } from '@reduxjs/toolkit'
import { find, findIndex } from 'lodash'

import types from './types'

export { default as actions } from './actions'

const INITIAL_STATE = {
  queue: [],
}

export default createReducer(INITIAL_STATE, {
  [types.ADD_SNACKBAR_ITEM]: (state, action) => {
    if (!find(state.queue, { key: action.payload.key })) {
      state.queue.push(action.payload)
    }
  },
  [types.DISMISS_SNACKBAR_ITEM]: (state, action) => {
    const idx = findIndex(state.queue, action.payload)
    state.queue.splice(idx, 1)
  },
})
